const module = { name: 'movie/shared/desktop/backgroundBlur', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';

function onResize() {
    const MAX_BLUR_HEIGHT = 3720;
    const backgroundHeight = $('.js-backgroundBlur').height();
    const isChrome = !!window.chrome;
    if (backgroundHeight < MAX_BLUR_HEIGHT || isChrome) {
        $('.js-backgroundBlur-image').attr('filter', 'url(#backgroundBlur)');
    }
}
function init() {
    onResize();
    $(window).on('resize', $.debounce(250, onResize));
}
module.exports = {
    init,
};
export default module.exports;